import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbCalendar, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { dateToNgb } from 'src/app/modules/core/services/datetime.service';
import { StatusService } from 'src/app/modules/core/services/parameter';
import { CustomValidates } from 'projects/common/src/app/classes/validateCustomForms';
import { Subscription } from 'rxjs';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';

@Component({
  selector: 'app-change-ubication',
  templateUrl: './change-ubication.component.html',
  styleUrls: ['./change-ubication.component.scss'],
})
export class ChangeUbicationComponent implements OnInit {
  @Input() public ubication: any;

  public today = new Date();
  public hour = this.today.getHours();
  public minute = this.today.getMinutes();
  // public dateFormated: string;

  public time = { hour: this.hour, minute: this.minute };
  public spinners = true;
  public message: string;
  public messageTime: string;

  public formUbication: FormGroup;
  public zoneTypes: any;
  public selectedUbication: any;
  public startDate: NgbDateStruct;
  public messageHour: boolean;
  public selectedDate: any;
  public disableChangeUbication: boolean;
  public subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private ubicationService: StatusService,
    private languageService: LanguageService,
    private calendar: NgbCalendar,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {
    this.disableChangeUbication = true;

    this.formUbication = this.fb.group(
      {
        zoneTypes: new FormControl(null, [Validators.required]),
        dateInput: new FormControl(new Date(), Validators.required),
        time: new FormControl('', Validators.required),
      },
      { validators: CustomValidates.validateHourAndDate },
    );
  }

  /**
   * Oninit
   */
  ngOnInit() {
    this.getAllZoneType();
    const customEvent = {
      modal_widget: 'asarco_state',
      tab_modal: 'asarco_state_change-ubication',
    };
    this.googleAnalyticsService.sendCustomEvent('modal', customEvent);
  }

  /**
   * Get all zone types from api.
   */
  private async getAllZoneType(): Promise<void> {
    this.ubicationService.getZonesChilds().then((result) => {
      const allZones = result.data;

      const filterZone = allZones.filter((f) => f.isLeaf === 1);
      this.zoneTypes = filterZone;
    });
  }

  /**
   * Selected Date
   */
  public changeStartDate($event: NgbDateStruct): void {
    let dateChange = `${$event.year}-`;
    dateChange += $event.month < 10 ? `0${$event.month}-` : `${$event.month}-`;
    dateChange += $event.day < 10 ? `0${$event.day}` : `${$event.day}`;

    this.selectedDate = dateChange;
    this.formUbication.controls.dateInput.patchValue(this.selectedDate);

    if (this.selectedDate !== '') {
      this.disableChangeUbication = false;
    } else {
      this.disableChangeUbication = true;
    }
  }

  /**
   * function to update ubication
   */
  public updateUbication(): void {
    const dateInput = this.formUbication.controls.dateInput.value;

    if (typeof dateInput === 'object') {
      const formatedDate = dateToNgb(dateInput);
      this.changeStartDate(formatedDate);
    }

    const { value } = this.formUbication;

    const hour = value.time.hour > 9 ? value.time.hour : `0${value.time.hour}`;
    const minute = value.time.minute > 9 ? value.time.minute : `0${value.time.minute}`;

    const time = value.time ? `${hour}:${minute}` : this.time;

    const params = {
      zoneId: value.zoneTypes.zoneId,
      date: this.selectedDate,
      time,
      machineId: this.ubication.machineId,
    };

    this.ubicationService.updateUbicationInsert(params).subscribe((data) => {
      if (data.error.errorNumber === 0) {
        this.message = this.languageService.message('ubication change successfull');
      }
    });
    this.disableChangeUbication = true;
  }

  /**
   * Clear form and delete style comment
   */
  public clear(): void {
    this.startDate = this.calendar.getToday();
    this.formUbication.controls.zoneTypes.setValue(this.zoneTypes.statusId);
    this.formUbication.controls.dateInput.setValue(this.startDate);
    this.formUbication.controls.time.setValue('00');
    this.disableChangeUbication = true;
  }
}
